export default __webpack_public_path__ + "static/assets/b649dcd4da5c78e38bd70b44041688e6.png";